import { render, staticRenderFns } from "./ManageSeminarClubCostDeduction.vue?vue&type=template&id=6d045562&"
import script from "./ManageSeminarClubCostDeduction.vue?vue&type=script&lang=js&"
export * from "./ManageSeminarClubCostDeduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports